// extracted by mini-css-extract-plugin
export var button = "_bo-0";
export var icon = "_bo-1";